export default __webpack_public_path__ + "static/media/seo-tag.2f9f67ad.png";